import { Asset, Item, ItemSetting } from 'able-lib'

export interface ParticipantSetting {
  note: boolean;
  chat: boolean;
}

export interface ExternalLinkInterface {
  url: string;
  show: boolean;
}

export interface SessionStoreInterface {
  session: Item;
  sessionSettings: Array<ItemSetting>;
  sessionSettingConnected: boolean;
  participantsSetting: ParticipantSetting;
  contentMaterials: Array<Asset>;
  questionExpansionStatus: boolean;
  externalLink: ExternalLinkInterface;
}

export default function (): SessionStoreInterface {
  return {
    session: null,
    sessionSettings: [],
    sessionSettingConnected: false,
    participantsSetting: {
      note: false,
      chat: false
    },
    contentMaterials: [],
    questionExpansionStatus: true,
    externalLink: {
      url: '',
      show: false
    }
  }
}
